import React, { useState, useEffect } from 'react';
import { Grid, Divider, Button, Chip } from '@material-ui/core';
import SearchBox from '../searchBox/SearchBox';
import SiteplanSection from './siteplanSection/SiteplanSection';
import PricingSection from './pricingSection/PricingSection';
import CoBrokerSection from './coBrokerSection/CoBrokerSection';
import FilterListIcon from '@material-ui/icons/FilterList';
import Modal from '../layout/modal/Modal';
import FilterPricing from './pricingSection/filterPricing/FilterPricing';
import styles from './SiteplanManagement.module.scss';
import { connect } from 'react-redux';
import {
	getLots,
	getBuildingInfo,
	getCoBrokers,
	getSalesAgents,
} from '../../redux/siteplanManagement/action';
import { checkRolesAccessibilities } from '../../utils/checkRolesAccessibilities';

const SiteplanManagement = (props) => {
	const {
		userDetails,
		rolesAccessibilities,
		getLots,
		getBuildingInfo,
		getCoBrokers,
		getSalesAgents,
	} = props;

	const [section, setSection] = useState('siteplan');
	const [pricingFilterModal, setPricingFilterModal] = useState(false);
	const [filteredLotSizeType, setFilteredLotSizeType] = useState('');
	const [filteredUnit, setFilteredUnit] = useState('');
	const [search, setSearch] = useState('');

	useEffect(() => {
		getLots(userDetails);
		getBuildingInfo();
		getCoBrokers();
		getSalesAgents();
	}, []);

	const handleSection = (e) => {
		var data = e.currentTarget.dataset.section;

		if (data === 'siteplan') {
			setSection(data);
		} else if (data === 'pricing') {
			setSection(data);
		} else if (data === 'coBorkers') {
			setSection(data);
		}
	};

	const openPricingFilterModal = () => {
		setPricingFilterModal(true);
	};

	const closePricingFilterModal = () => {
		setPricingFilterModal(false);
	};

	const handleDeleteFilteredLotSizeType = () => {
		setFilteredLotSizeType('');
	};

	const handleDeleteFilteredUnit = () => {
		setFilteredUnit('');
	};

	return (
		<div className={styles.siteplan_management_page}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<div className={styles.siteplan_management_header}>
						<div className={styles.header_group}>
							<p className={styles.header_text}>
								Site Plan Management
							</p>
							<div>
								<SearchBox
									placeholder='Search'
									handleChange={(e) =>
										setSearch(e.target.value)
									}
								/>
							</div>
						</div>
						<Divider />
					</div>
				</Grid>
				<Grid item xs={12} className={styles.selector_header}>
					<div className={styles.selector_group}>
						<div
							className={`${styles.selector_btn}  ${
								section === 'siteplan' ? styles.active : ''
							}`}
							data-section='siteplan'
							onClick={(e) => handleSection(e)}
						>
							Site Plan
						</div>
						{checkRolesAccessibilities(
							rolesAccessibilities,
							userDetails.userType,
							'siteplan',
							'siteplan',
							0
						) && (
							<div
								className={`${styles.selector_btn}  ${
									section === 'pricing'
										? styles.active
										: ''
								}`}
								data-section='pricing'
								onClick={(e) => handleSection(e)}
							>
								Pricing
							</div>
						)}
						{checkRolesAccessibilities(
							rolesAccessibilities,
							userDetails.userType,
							'siteplan',
							'siteplan',
							1
						) && (
							<div
								className={`${styles.selector_btn}  ${
									section === 'coBorkers'
										? styles.active
										: ''
								}`}
								data-section='coBorkers'
								onClick={(e) => handleSection(e)}
							>
								Co-Brokers
							</div>
						)}
					</div>
					{section === 'pricing' && (
						<div>
							<Button
								className={styles.pricing_filter}
								startIcon={<FilterListIcon />}
								onClick={openPricingFilterModal}
							>
								Filter
							</Button>
							{filteredLotSizeType &&
								filteredLotSizeType !== '' && (
									<Chip
										label={filteredLotSizeType + "'"}
										variant='outlined'
										size='small'
										className={styles.pricing_filter_chip}
										onDelete={
											handleDeleteFilteredLotSizeType
										}
									/>
								)}
							{filteredUnit && filteredUnit !== '' && (
								<Chip
									label={filteredUnit}
									variant='outlined'
									size='small'
									className={styles.pricing_filter_chip}
									onDelete={handleDeleteFilteredUnit}
								/>
							)}
						</div>
					)}
				</Grid>
				{section === 'siteplan' && <SiteplanSection />}
				{section === 'pricing' && (
					<PricingSection
						filteredLotSizeType={filteredLotSizeType}
						filteredUnit={filteredUnit}
						search={search}
					/>
				)}
				{section === 'coBorkers' && <CoBrokerSection search={search} />}
			</Grid>
			<div className={styles.pricing_filter_modal}>
				<Modal
					show={pricingFilterModal}
					title='Filters'
					close={closePricingFilterModal}
				>
					<FilterPricing
						closePricingFilterModal={closePricingFilterModal}
						setFilteredLotSizeType={setFilteredLotSizeType}
						setFilteredUnit={setFilteredUnit}
					/>
				</Modal>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	userDetails: state.signIn,
	rolesAccessibilities: state.userManagement.rolesAccessibilities,
});

export default connect(mapStateToProps, {
	getLots,
	getBuildingInfo,
	getCoBrokers,
	getSalesAgents,
})(SiteplanManagement);
